export default __webpack_public_path__ + "static/media/cryptocurrency.a292dc2f.jpg";